import { IconButton, InputAdornment, TextField, TextFieldProps } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

type Props = Omit<TextFieldProps, "value" | "onChange"> & {
  value: string;
  onChange: (value: string) => void;
};

// A text field with an X in the end adornment that clears it. The X is only
// shown while there is something to clear.
const ClearableTextField = ({ value, onChange, slotProps, ...rest }: Props) => (
  <TextField
    {...rest}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    slotProps={{
      ...slotProps,
      input: {
        ...(slotProps?.input as object),
        endAdornment: value ? (
          <InputAdornment position="end">
            <IconButton
              size="small"
              edge="end"
              aria-label={`Clear ${String(rest.label || "field").toLowerCase()}`}
              onClick={() => onChange("")}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : undefined,
      },
    }}
  />
);

export default ClearableTextField;
